import { useEffect } from 'react';
import { initCookieConsent } from '../utils/cookieConsentConfig';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

const CookieConsent = () => {
    useEffect(() => {
        initCookieConsent();
    }, []);

    return null;
};

export default CookieConsent;
